import React, { useState, useEffect } from 'react';

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled 
          ? 'bg-paper/85 backdrop-blur-md border-b border-hairline' 
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk h-20 flex items-center justify-between">
        <a href="#" className="flex flex-col group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink rounded-sm">
          <span className="font-heading font-semibold text-[22px] text-ink leading-none tracking-tight">
            Leadcons
          </span>
          <span className="font-mono text-[11px] uppercase text-graphite tracking-[0.12em] mt-0.5 leading-none">
            by Md Abu Musa
          </span>
        </a>
        
        <nav className="flex items-center gap-8">
          <div className="hidden md:flex items-center gap-6 font-body text-[15px] text-ink">
            <a href="#about" className="hover:text-graphite transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink rounded-sm">About</a>
            <a href="#services" className="hover:text-graphite transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink rounded-sm">Services</a>
            <a href="#process" className="hover:text-graphite transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink rounded-sm">Process</a>
            <a href="#faq" className="hover:text-graphite transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink rounded-sm">FAQ</a>
          </div>
          <a 
            href="#book" 
            className="flex items-center justify-center h-10 px-5 bg-ink text-paper font-body text-[15px] rounded-sm hover:bg-ink/90 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2"
          >
            Book a call
          </a>
        </nav>
      </div>
    </header>
  );
}